export const config = {
  stats: false,
  version: 2.31,
  imageBucketURL: "https://s3.us-east-2.amazonaws.com/366images/",
  apiBase: "https://optiqalapis.com:3334/catsplussearchapp",
  homeImg: "catsPlusLogo.png",
  appName: "Cats Plus Search App",
};
